import Game from "./Game.js";
import AContainer from "../../library/ExtendedObjects/AContainer.js";
import gameData from "../../gameData.js";
import { Audio } from "@abcya/abcya_phaser";
import ABCyaLib from "@abcya/abcya_lib";

export default class Game_Instructions extends AContainer
{
    /**
     * @param {Game} scene 
     */
    constructor(scene)
    {
        super(scene);

        this.scene = scene;
        let instructionSound;


        this.overlay = this.create(0, 0, "bg_forest");
        this.overlay.tint = 0x000000;
        this.overlay.setInteractive();

        this.emitter = this.scene.add.particles(this.scene.defaultAtlas, 'SnakeParticle').createEmitter({
            tint: [0xffffff],
            scale: { start: .8, end: 0 },
            speed: {min: -100, max: 100 },
            quantity: 200
        });
        this.emitZone = {
            source: new Phaser.Geom.Rectangle(-275, -175, 550, 350),
            type: 'edge',
            quantity: 50
        };
        this.emitter.setEmitZone(this.emitZone);
        this.emitter.stop();
        this.add(this.emitter.manager);

        this.popupContainer = this.scene.add.container(0, 0);
        
        this.add(this.popupContainer);
       
        let popupFrame = gameData.curGameType == "COUNT" ? "popup_count" : gameData.curGameType == "READ" ? "popup_read" : "popup_listen";
        
        this.scene.addImage(0, 0, popupFrame, this.popupContainer);
        this.okButton = this.scene.addButton(0, 130, "BTN_okOff", {frameOnDown: "BTN_okOn"}, ()=>{
            this.hidePopup(instructionSound);
        }, this.popupContainer);

        this.overlay.on("pointerdown", ()=>{
            this.hidePopup(instructionSound);
        });

        this.popupContainer.alpha = 0;
        this.popupContainer.setScale(1.5);
        this.overlay.alpha = 0;

        this.hand = this.scene.addImage(this.scene.mid.x, this.scene.mid.y, "Instrux_Hand").setDepth(2);
        this.hand.alpha = 0;
        this.dummySnake = this.scene.addImage(58, 240, (gameData.curSnakeIndex + 1) + "_game1").setDepth(1);
        if(!ABCyaLib.Environment.instance.gameConfig.hundredsFill) {
          this.dummySnake.setPosition(186, 333);
        }
        this.dummySnake.alpha = 0;

        if(gameData.gameTypes[gameData.curGameType].stagesComplete <= 0 && gameData.gameTypes[gameData.curGameType].curCorrect <= 0) instructionSound = this.displayPopup();
    }

    displayPopup()
    {
        let soundFile = gameData.curGameType == "COUNT" ? "count_write_directions" : gameData.curGameType == "READ" ? "read_make_directions" : "listen_make_directions";
        let instructionSound = this.scene.playSound(soundFile, 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);

        this.scene.killTween(this.popupContainer);
        this.scene.killTween(this.overlay);

        this.popupContainer.setScale(1.5);

        this.scene.addTween(this.overlay, 300, {alpha: .4});
        this.scene.addTween(this.popupContainer, 300, {alpha: 1});
        this.scene.addTween(this.popupContainer, 1000, {scaleX: 1, scaleY: 1}, "Bounce");
        this.scene.addDelay(300, ()=>{
            this.emitter.explode(300);
            this.scene.addDelay(200, ()=>{
                this.emitter.explode(150);
                this.scene.addDelay(100, ()=>{
                    this.emitter.explode(75);
                });
            });
        });

        return instructionSound;
    }

    hidePopup(instructionSound)
    {
        this.scene.killTween(this.popupContainer);
        this.scene.killTween(this.overlay);

        this.scene.addTween(this.popupContainer, 300, {alpha: 0, scaleX: 0, scaleY: 0});
        this.scene.addTween(this.overlay, 300, {alpha: 0});

        if(gameData.curGameType == "LISTEN" || (gameData.curGameType === 'READ' && ABCyaLib.Environment.instance.gameConfig.subtitle !== null))
        {
            let delay = 500;
            if(instructionSound.isPlaying){
                instructionSound.on('complete', ()=>{
                    this.scene.addDelay(700, ()=>{
                        this.scene.ui.title.speakNumber();
                    });
                })
            }
            //500 is to give the tween time to finish
            else{
                this.scene.addDelay(700, ()=>{
                    this.scene.ui.title.speakNumber();
                });
            }
        }

        if(gameData.curGameType != "COUNT")
        {
          let handPos = {x: 90, y: 300};
          
          if(!ABCyaLib.Environment.instance.gameConfig.hundredsFill) {
            handPos = {x: 219, y: 394};
          }

            this.hand.setPosition(this.scene.mid.x, this.scene.mid.y);
            this.scene.addTween(this.hand, 400, {alpha: 1, delay: 300});
            this.scene.addTween(this.hand, 1500, {x: handPos.x, y: handPos.y, delay: 300}, Phaser.Math.Easing.Sine.Out, ()=>{
                this.scene.addTween(this.hand, 200, {scaleX: .9, scaleY: .9}, Phaser.Math.Easing.Sine.Out, ()=>{
                    this.dummySnake.alpha = 1;

                    this.scene.addTween(this.hand, 1500, {x: this.scene.mid.x, y: this.scene.mid.y, onUpdate:()=>{
                        this.dummySnake.setPosition(this.hand.x - 32, this.hand.y - 60);
                    }}, Phaser.Math.Easing.Sine.Out, ()=>{
                        this.scene.addTween(this.hand, 400, {scaleX: 1.2, scaleY: 1.2, alpha: 0}, Phaser.Math.Easing.Sine.Out, ()=>{
                            this.scene.addTween(this.dummySnake, 200, {alpha: 0, delay: 400}, Phaser.Math.Easing.Sine.Out);
                        });
                    });
                });
                
            });
        }
    }
}